import config from "../../utils/config";



/////// ******* CLOUDBEDS FUNCTIONS ******* \\\\\\\

/* check access token */
//todo: everything
export async function checkAccessToken() {
  const res = await fetch(config.cloudbeds.checkTokenUrl, { // POST to our backend server with the token and charge details

    method: 'POST',
    headers:
      { 'x-api-key': 'VP9JW5IUbI96QP09Ac6Cz8wY98jjVkfs9Hk1LOhE'
      },
    body: JSON.stringify({
       dummy:'dummy'
      }
    ),

  });

  const data = await res.json();
 // let raw = await JSON.parse(data.body)

  //console.log(await data)

  return await data
}

/* get access token */
//todo: everything
export async function getAccessToken() {
  const res = await fetch(config.cloudbeds.getTokenUrl, { // POST to our backend server with the token and charge details

    method: 'POST',
    headers:
      { 'x-api-key': 'VP9JW5IUbI96QP09Ac6Cz8wY98jjVkfs9Hk1LOhE'
         },
    body: JSON.stringify({
       refresh_token  :'dummy'
      }
    ),

  });

  const data = await res.json();
 // let raw = await JSON.parse(data.body)

  //console.log(await data)

  return await data
}


/* get available rooms & rates */
//todo: everything
export async function getRatePlans(startDate, endDate, token) {

  const res = await fetch(config.cloudbeds.getRatePlansUrl, { // POST to our backend server with the token and charge details

    method: 'POST',
    headers:
      { 'x-api-key': 'VP9JW5IUbI96QP09Ac6Cz8wY98jjVkfs9Hk1LOhE'
      },
    body: JSON.stringify({
        accessToken: token.access_token,
        startDate: startDate,
        endDate: endDate,
      }),

  });

  const data = await res.json();
 // let raw = await JSON.parse(data.body)

  console.log(await data)

  return await data
}


/* post reservation*/
export async function postReservation(data, tok) {
  const token = tok
const obj = {
  accessToken:token.access_token,
  startDate: data.startDate,
  endDate:data.endDate,
  guestFirstName:data.guestFirstName,
  guestLastName:data.guestLastName,
  guestZipCode:data.guestZipCode,
  guestCountry:data.guestCountry,
  guestEmail:data.guestEmail,
  rooms: data.rooms,
  adults:data.adults,
  children:data.children,
  paymentMethod:data.paymentMethod,
  stripe_customer_id:data.stripe_customer_id,



}
//console.log(obj)
  //console.log(tok)
  const res = await fetch(config.cloudbeds.postReservationUrl, { // POST to our backend server with the token and charge details

    method: 'POST',
    headers:
      { 'x-api-key': 'VP9JW5IUbI96QP09Ac6Cz8wY98jjVkfs9Hk1LOhE'
      },
    body: JSON.stringify({
      accessToken:token.access_token,
      startDate: data.startDate,
      endDate:data.endDate,
      guestFirstName:data.guestFirstName,
      guestLastName:data.guestLastName,
      guestZipCode:data.guestZipCode,
      guestCountry:data.guestCountry,
      guestEmail:data.guestEmail,
      rooms: data.rooms,
      adults:data.adults,
      children:data.children,
      paymentMethod:data.paymentMethod,
      stripe_customer_id:data.stripe_customer_id,
      company:data.company,
      address1:data.address1,
      city:data.city
      }
    ),


  });

  const response = await res.json();
  // let raw = await JSON.parse(data.body)

  //console.log(await response)

  return await response
}


/* post items to a reservation  */
//todo: everything
export async function postReservationItem(item,res_id, token) {
 // const token = await getAccessToken()
  //console.log('ready to post reservation item')
  //console.log(token)
  //console.log(item)
  //console.log(res_id)
  const res = await fetch(config.cloudbeds.postReservationItemUrl, { // POST to our backend server with the token and charge details

    method: 'POST',
    headers:
      { 'x-api-key': 'VP9JW5IUbI96QP09Ac6Cz8wY98jjVkfs9Hk1LOhE'
      },
    body: JSON.stringify({
        accessToken:token.access_token,
        reservationID:res_id,
      itemID: item.itemID,
      itemQuantity: item.itemQuantity
    }
    ),

  });

  const data = await res.json();


  return await data
}


/* post reservation notes if set */
//todo: everything
export async function postReservationNotes(notes, res_id, token) {
 // const token = await getAccessToken()
  //console.log('ready to post reservation notes')
//console.log(token)
//console.log(notes)
//console.log(res_id)
  const res = await fetch(config.cloudbeds.postReservationNotesUrl, { // POST to our backend server with the token and charge details

    method: 'POST',
    headers:
      { 'x-api-key': 'VP9JW5IUbI96QP09Ac6Cz8wY98jjVkfs9Hk1LOhE'
      },
    body: JSON.stringify({
      accessToken: token.access_token,
      reservationID: res_id,
      reservationNote: notes,


    }),

  });

  const data = await res.json();
//console.log(res)
  //console.log('onToken');

  //console.log(data);

return await data

}


/* post payment to reservation */
//todo: everything
export async function postPayment(payment, token) {
 // const token = await getAccessToken()
//console.log(token)
//console.log(payment)
  const res = await fetch(config.cloudbeds.postPaymentUrl, { // POST to our backend server with the token and charge details

    method: 'POST',
    headers:
      { 'x-api-key': 'VP9JW5IUbI96QP09Ac6Cz8wY98jjVkfs9Hk1LOhE'
      },
    body: JSON.stringify({
      accessToken: token.access_token,
      reservationID: payment.reservationID,
      type: payment.type,
      amount: payment.amount,
      description: payment.description,


    }),

  });

  const data = await res.json();
  //console.log(res)
  //console.log('onToken');

  //console.log(data);

  return await data

}/* get reservation/s */
//todo: everything
export async function getReservation(reservationID) {
  const token = await getAccessToken()

  const res = await fetch(config.cloudbeds.getReservationUrl, { // POST to our backend server with the token and charge details

    method: 'GET',
    headers:
      { 'x-api-key': 'VP9JW5IUbI96QP09Ac6Cz8wY98jjVkfs9Hk1LOhE'
      },
    body: JSON.stringify({
      accessToken:token.access_token,
      reservationID: reservationID,


    }),

  });

  const data = await res.json();
  //console.log(res)
  //console.log('onToken');

  //console.log(data);

  return await data

}

/* get reservation invoice information */
//todo: everything
export async function getInvoiceInfo(reservationID) {
  const tt = await getAccessToken()
  const token = await JSON.parse(tt.body)

//console.log('ready to get invoice information')
  //console.log(token.access_token)
  //console.log(reservationID)
  const res = await fetch(config.cloudbeds.getInvoiceInfoUrl, { // POST to our backend server with the token and charge details

    method: 'POST',
    headers:
      { 'x-api-key': 'VP9JW5IUbI96QP09Ac6Cz8wY98jjVkfs9Hk1LOhE'
      },
    body: JSON.stringify({
      accessToken:token.access_token,
      reservationID: reservationID,


    }),

  });

  const data = await res.json();
  //console.log(res)
  //console.log('onToken');

  //console.log(data);

  return await JSON.parse(data.body)

}



/* confirm reservation*/
//todo: everything
export async function confirmReservation(reservationID) {
  const token = await getAccessToken()


  const res = await fetch(config.cloudbeds.confirmReservationUrl, { // POST to our backend server with the token and charge details

    method: 'POST',
    headers:
      { 'x-api-key': 'VP9JW5IUbI96QP09Ac6Cz8wY98jjVkfs9Hk1LOhE'
      },
    body: JSON.stringify({
      accessToken:token.access_token,
      reservationID: reservationID,


    }),

  });

  const data = await res.json();
  //console.log(res)
  //console.log('onToken');

  //console.log(data);

  return await data
}

/* cancel reservation*/
//todo: everything
export async function cancelReservation(reservationID) {
  const token = await getAccessToken()

  const res = await fetch(config.cloudbeds.cancelReservationUrl, { // POST to our backend server with the token and charge details

    method: 'POST',
    headers:
      { 'x-api-key': 'VP9JW5IUbI96QP09Ac6Cz8wY98jjVkfs9Hk1LOhE'
      },
    body: JSON.stringify({
      accessToken:token.access_token,
      reservationID: reservationID,


    }),

  });

  const data = await res.json();
  //console.log(res)
  //console.log('onToken');

  //console.log(data);

  return await data
}


/* post arrival time*/
//todo: everything
export async function postArrivalTime(estimatedArrivalTime, res_id) {
  const token = await getAccessToken()

  const res = await fetch(config.cloudbeds.postArrivalTimeUrl, { // POST to our backend server with the token and charge details

    method: 'POST',
    headers:
      { 'x-api-key': 'VP9JW5IUbI96QP09Ac6Cz8wY98jjVkfs9Hk1LOhE'
      },
    body: JSON.stringify({
      accessToken:token.access_token,
      estimatedArrivalTime: estimatedArrivalTime,
      reservationID:res_id

    }),

  });

  const data = await res.json();
  //console.log(res)
  //console.log('onToken');

  //console.log(data);

  return await data
}

/* add custom invoice template to reservation*/
//todo: zukunftsmusik
export async function postInvoice(pdf) {
  const token = await getAccessToken()

  const res = await fetch(config.cloudbeds.addInvoiceUrl, { // POST to our backend server with the token and charge details

    method: 'POST',
    headers:
      { 'x-api-key': 'VP9JW5IUbI96QP09Ac6Cz8wY98jjVkfs9Hk1LOhE'
      },
    body: JSON.stringify({
      accessToken:token.access_token,
      invoice: pdf,


    }),

  });

  const data = await res.json();
  //console.log(res)
  //console.log('onToken');

  //console.log(data);

  return await data

}



/* assign/re-assign room*/
//todo: zukunftsmusik
export async function postRoomAssign(stripe_customer_id, amount, auth0_user_id) {
}



/* update guest/*/
//todo: everything
export async function putGuest(newGuest) {
  const t = await getAccessToken()
  const token = await JSON.parse(t.body)

  const res = await fetch(config.cloudbeds.putGuestUrl, { // POST to our backend server with the token and charge details

    method: 'POST',
    headers:
      { 'x-api-key': 'VP9JW5IUbI96QP09Ac6Cz8wY98jjVkfs9Hk1LOhE'
      },
    body: JSON.stringify({
      accessToken:token.access_token,
      guestData: newGuest,


    }),

  });

  const data = await res.json();
  //console.log(res)
  //console.log('onToken');

  //console.log(data);

  return await data
}

/* get guest/*/
//todo: everything
export async function getGuest(guestID, parsedTok) {
//console.log('ready to get guest')
  //console.log(guestID)
  //console.log(parsedTok.access_token)

  const res = await fetch(config.cloudbeds.getGuestUrl, { // POST to our backend server with the token and charge details

    method: 'POST',
    headers:
      { 'x-api-key': 'VP9JW5IUbI96QP09Ac6Cz8wY98jjVkfs9Hk1LOhE'
      },
    body: JSON.stringify({
      accessToken:parsedTok.access_token,
      guestID: guestID,


    }),

  });

  const data = await res.json();
  //console.log(res)
  //console.log('onToken');

  //console.log(data);

  return await data
}


export function setTimeOut(){
  setTimeout(function(){},1000)
}


